import { render, staticRenderFns } from "./ApiInfo.vue?vue&type=template&id=464d5404&scoped=true&"
import script from "./ApiInfo.vue?vue&type=script&lang=js&"
export * from "./ApiInfo.vue?vue&type=script&lang=js&"
import style0 from "./ApiInfo.vue?vue&type=style&index=0&id=464d5404&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464d5404",
  null
  
)

export default component.exports